import React from 'react'
import { Redirect } from '../helpers/Common'

class Home extends React.Component {
  render () {
    return (
      <Redirect to='/login' />
    )
  }
}

export default Home
